import Model from "../base/model";

class TakerBankAccount extends Model{
  resourceName() {
    return "taker_bank_accounts";
  }

  fields() {
    return {
      "bank": "",
      "agency": "",
      "number": "",
      "editable": "",
      "transporter_id": "",
    }
  }
}

export default new TakerBankAccount();
